module.exports = __webpack_public_path__ + "img/icone-quanta-Shop.4cc179bc.png";